import * as React from "react";
const SvgFiRrRentSignal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rent-signal_svg__a)">
      <path
        fill="#062147"
        d="M10 2a2 2 0 1 1 3.999-.001A2 2 0 0 1 10 2M4.5 14.6h-.9v1.8h.9c.496 0 .9-.404.9-.9s-.404-.9-.9-.9M24 14v6a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-6c0-2.046 1.541-3.713 3.522-3.952l4.925-5.234a1.001 1.001 0 0 1 1.457 1.371L6.314 10h11.371l-3.59-3.815a1.001 1.001 0 0 1 1.457-1.371l4.926 5.234C22.459 10.287 24 11.954 24 14M5.933 17.544a2.49 2.49 0 0 0 1.047-2.362C6.822 13.908 5.65 13 4.367 13H2.8a.8.8 0 0 0-.8.8v6.4a.8.8 0 1 0 1.6 0V18h.784l.705 2.423a.8.8 0 0 0 .768.577h.063a.8.8 0 0 0 .765-1.033l-.739-2.43.042-.029c-.019.012-.031.021-.055.035zM9.6 16.189V14.6h.62a.8.8 0 0 0 0-1.6H8.8a.8.8 0 0 0-.8.8v6.391a.8.8 0 0 0 .8.8h1.42a.8.8 0 0 0 0-1.6H9.6v-1.602h.62a.8.8 0 0 0 0-1.6zM17 13.8a.8.8 0 1 0-1.6 0v3.263l-1.545-3.486a.969.969 0 0 0-1.855.392V20.2a.8.8 0 1 0 1.6 0v-3.254l1.544 3.478A.97.97 0 0 0 17 20.03zm5.003.026a.8.8 0 0 0-.8-.8h-2.404a.8.8 0 0 0 0 1.6h.401V20.2a.8.8 0 0 0 1.6 0v-5.574h.403a.8.8 0 0 0 .8-.8"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rent-signal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRentSignal;
